import { currentEventId, EventJournalModalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const useTextEventJournalItem = () => {
    const { setState: setModalState } = useNuqsQueryState(EventJournalModalQueries.queryName);
    const { setState: setCurrentEventId } = useNuqsQueryState(currentEventId);
    const handleTextEventClick = (eventId: number, type: string | 'custom') => {
        if (type != 'custom') {
            return;
        }
        void setModalState(EventJournalModalQueries.queryEdit);
        void setCurrentEventId(String(eventId));
    };
    return { handleTextEventClick };
};
